export default __webpack_public_path__ + "static/media/logo.b29b88c7.jpg";